import analytics from '@utils/analytics';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import customEventBus from '@common/scripts/libs/eventBus';
const FaqSearch = (props) => {
    const { t } = useTranslation();
    const [results, setResults] = useState([]);
    const [query, setQuery] = useState('');
    // add listener from outside via CustomEventBus
    useEffect(() => {
        customEventBus.on('faqSearch:back', () => {
            setResults([]);
            setQuery('');
        });
    }, []);
    useEffect(() => {
        //query in listen per reinit di Swiper in StoriesCarousel, line 47;
        customEventBus.emit('query:update', { query: query });
    }, [query]);
    useEffect(() => {
        customEventBus.emit('faqSearch:update', { results: results });
    }, [results]);
    return (React.createElement("div", { className: "faq-search" },
        React.createElement("div", { className: "search-input" },
            React.createElement("input", { type: "search", placeholder: t('label.search'), "aria-label": t('label.search'), onFocus: () => {
                    analytics.startCSSearch();
                }, onChange: (e) => {
                    //@ts-ignore
                    setQuery(e.currentTarget.value);
                }, value: query }),
            query.length >= 1 && (React.createElement("button", { className: "icon--close", onClick: () => {
                    setResults([]);
                    setQuery('');
                }, "aria-label": t('button.close') })))));
};
export default FaqSearch;
